
//url
let strRegex = '^((https|http|ftp|rtsp|mms)?://)'
  + '?(([0-9a-z_!~*\'().&=+$%-]+: )?[0-9a-z_!~*\'().&=+$%-]+@)?' //ftp的user@
  + '(([0-9]{1,3}.){3}[0-9]{1,3}' // IP形式的URL- 199.194.52.184
  + '|' // 允许IP和DOMAIN（域名）
  + '([0-9a-z_!~*\'()-]+.)*' // 域名- www.
  + '([0-9a-z][0-9a-z-]{0,61})?[0-9a-z].' // 二级域名
  + '[a-z]{2,6})' // first level domain- .com or .museum
  + '(:[0-9]{1,5})?' // 端口- :80
  + '((/?)|' // a slash isn't required if there is no file name
  + '(/[0-9a-z_!~*\'().;?:@&=+$,%#-]+)+/?)$';
export const urlReg = new RegExp(strRegex);


//正整数
export const positiveIntReg = /^[0-9]+$/;

//大于0正整数
export const greaterIntReg = /^[1-9]\d*$/;

// 整数
export const intReg = /^-?\d+$/;

//邮箱
export const emailReg = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,5}$/;


//0~1保留三位小数
export const decimalReg = /^0\.\d{0,3}$|^1\.?0{0,3}$/;


//非负两位小数
export const negativeDecimal = /^[0-9]+([.]{1}[0-9]{1,2})?$/;


//手机号码
export const phoneReg = /^1(3|4|5|6|7|8|9)\d{9}$/;

//金钱校验
export const moneyReg = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/;

//字母、数字、汉字
export const letterNum = /^[a-zA-Z0-9\u4e00-\u9fa5.]+$/;
